module.exports = __webpack_public_path__ + "img/watermark-gray3.796277d6.png";